// @flow
import React, { Fragment, useState, useEffect } from "react";
import Button from "../Button";
import { post } from "../../lib/Fetching";

export default function TraySampleActionBar({
  selectedSamples,
  reloadData,
  toolbarOptions: { onScheduled, tray },
}) {
  const [loading, setLoading] = useState(false);

  const handleRemoveSamples = () => {
    if (selectedSamples.length === 0) return;

    setLoading(true);
    post("/trays/trays/" + tray.id + "/remove_samples.json", {
      sample_ids: selectedSamples.map((s) => s.identifier),
    }).then((json) => {
      setLoading(false);
      reloadData();
    });
  };

  if (tray.finished) {
    return null;
  }

  return (
    <div style={{ padding: 10, paddingBottom: 0 }}>
      <Button
        title="Remove Samples from Tray"
        disabled={selectedSamples.length === 0 || loading}
        deleting
        icon={loading ? "fa-spinner fa-spin" : "fa-trash"}
        onClick={handleRemoveSamples}
        tiny
      />
    </div>
  );
}
